<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-container-single element-non-bodymatter element-type-toc" id="table-of-contents">
<div class="toc-heading"><h1 class="toc-title">Contents</h1></div>
<div class="toc-contents">
<div class="toc-frontmatter-group">
<div class="toc-item toc-item-element-non-bodymatter toc-item-element-type-foreword has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><a href="#/foreword"><span class="element-title-text">Foreword</span></a></p>
</div>
<div class="toc-item toc-item-element-non-bodymatter toc-item-element-type-introduction has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><a href="#/introduction"><span class="element-title-text">Introduction</span></a></p>
</div>
</div>
<div class="toc-bodymatter-group">
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number">
<p class="element-title"><span class="element-number">1. </span><a href="#/chapter001"><span class="element-title-text">Who Are You?</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number">
<p class="element-title"><span class="element-number">2. </span><a href="#/chapter002"><span class="element-title-text">Christ-Centered Fitness</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number">
<p class="element-title"><span class="element-number">3. </span><a href="#/chapter003"><span class="element-title-text">A Transformed Life Through a Transformed Mind</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number">
<p class="element-title"><span class="element-number">4. </span><a href="#/chapter004"><span class="element-title-text">Faith and Fitness</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number">
<p class="element-title"><span class="element-number">5. </span><a href="#/chapter005"><span class="element-title-text">Physically Fit People in the Bible</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number">
<p class="element-title"><span class="element-number">6. </span><a href="#/chapter006"><span class="element-title-text">Christ-Centered Workouts</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number">
<p class="element-title"><span class="element-number">7. </span><a href="#/chapter007"><span class="element-title-text">Strength Training Workouts</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number">
<p class="element-title"><span class="element-number">8. </span><a href="#/chapter008"><span class="element-title-text">Dynamic Home Workouts</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number">
<p class="element-title"><span class="element-number">9. </span><a href="#/chapter009"><span class="element-title-text">Cardio Kings and Queens</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number">
<p class="element-title"><span class="element-number">10. </span><a href="#/chapter010"><span class="element-title-text">Workout Principles</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number">
<p class="element-title"><span class="element-number">11. </span><a href="#/chapter011"><span class="element-title-text">The Law of Sowing and Reaping</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number">
<p class="element-title"><span class="element-number">12. </span><a href="#/chapter012"><span class="element-title-text">Revealing the Keys to Nutrition</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number">
<p class="element-title"><span class="element-number">13. </span><a href="#/chapter013"><span class="element-title-text">Can We Skip Nutrients?</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-leading-number has-no-children has-no-page-number">
<p class="element-title"><span class="element-number">14. </span><a href="#/chapter014"><span class="element-title-text">A Chosen Generation: What the Future Holds</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><a href="#/salvationprayer"><span class="element-title-text">Salvation Prayer</span></a></p>
</div>
</div>
<div class="toc-backmatter-group">
<div class="toc-item toc-item-element-non-bodymatter toc-item-element-type-none has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><a href="#/beforeyougo"><span class="element-title-text">Before You Go…</span></a></p>
</div>
<div class="toc-item toc-item-element-non-bodymatter toc-item-element-type-acknowledgments has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><span href="#/acknowledgments" title="Link target outside of Sample"><span class="element-title-text">Acknowledgments</span></span></p>
</div>
<div class="toc-item toc-item-element-non-bodymatter toc-item-element-type-about-author has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><a href="#/abouttheauthor"><span class="element-title-text">About the Author</span></a></p>
</div>
<div class="toc-item toc-item-element-non-bodymatter toc-item-element-type-none has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><a href="#/workscited"><span class="element-title-text">Works Cited</span></a></p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?cfc1b3ca